var customerId = "";
var isNewTokenGenerated = false;

// validate the token and returns the the token
function tokenValidator(token,resCustomerId){
  
  if(token !== ""){
    var tokenExpiryTimeStampString = decodeToken(token,resCustomerId);
    if(tokenExpiryTimeStampString !== ""){
      var tokenExpiryTimeStamp = new Date(tokenExpiryTimeStampString);
  	  var now = new Date();
    var isTokenExpired = "";
    var localStorageCustomerId = resCustomerId.toString();
    var newGeneratedToken = "";
    
    var tokenExpiryYear = tokenExpiryTimeStamp.getFullYear();
    var tokenExpiryMonth = tokenExpiryTimeStamp.getMonth();
    var tokenExpiryDate = tokenExpiryTimeStamp.getDate();
   
    
    var nowUtcYear = now.getUTCFullYear();
    var nowUtcMonth = now.getUTCMonth();
    var nowUtcDate = now.getUTCDate();
    
    if(tokenExpiryYear >= nowUtcYear && tokenExpiryMonth >= nowUtcMonth && tokenExpiryDate > nowUtcDate){
      isTokenExpired = false;
    }
    else if(tokenExpiryYear === nowUtcYear && tokenExpiryMonth === nowUtcMonth && tokenExpiryDate === nowUtcDate){
      
      var tokenExpiryHour = tokenExpiryTimeStamp.getHours();
      var tokenExpiryMinutes = tokenExpiryTimeStamp.getMinutes();
      var tokenExpirySeconds = tokenExpiryTimeStamp.getSeconds();
      
      var nowUtcHours = now.getUTCHours();
      var nowUtcMinutes = now.getUTCMinutes();
      var nowUtcSeconds = now.getUTCSeconds();
      
      
      if(tokenExpiryHour > nowUtcHours){
        isTokenExpired = false;
      }
      else if(tokenExpiryHour === nowUtcHours){
        if(tokenExpiryMinutes > nowUtcMinutes){
          isTokenExpired = false;
        }
        else if(tokenExpiryMinutes === nowUtcMinutes){
          if(tokenExpirySeconds > nowUtcSeconds){
            isTokenExpired = false;
          }
          else{
            isTokenExpired = true;
          }
        }
        else{
          isTokenExpired = true;
        }
      }
      else{
        isTokenExpired = true;
      }
    }
    else{
      isTokenExpired = true;
    }
    
    
    if(isTokenExpired === false){
      return token;
    }
    else{
      newGeneratedToken = generateToken(resCustomerId);
      return newGeneratedToken;
    }
      
    }
    else{
      newGeneratedToken = generateToken(resCustomerId);
      return newGeneratedToken;
    }
  }
  else{
    newGeneratedToken = generateToken(resCustomerId);
    return newGeneratedToken;
  }
}

// function to decode the token
function decodeToken(token,resCustomerId){
  if(token !== ""){
    var isValidToken = token.indexOf(".");
    if(isValidToken !== -1){
      var tokenArray = token.split(".");
      if(tokenArray.length === 3){
        var tokenObj = JSON.parse(atob(token.split('.')[1]));
        if(!($.isEmptyObject(tokenObj))){
          var isCustomerIdExists = tokenObj.hasOwnProperty("sub");
          var isIatExists = tokenObj.hasOwnProperty("iat");
          var isExpirySecondsExists = tokenObj.hasOwnProperty("exp");
          if(isCustomerIdExists === true && isIatExists === true && isExpirySecondsExists === true){
            var tokenIssuedAt = "";
            var expireSeconds = 0;
            if(tokenObj.sub !== null && tokenObj.sub !== "" && tokenObj.sub === resCustomerId){
              //   customer id taken from token
  				   customerId = tokenObj.sub;
              if(tokenObj.iat !== null && tokenObj.iat !== ""){
                //   token generated at
  				 tokenIssuedAt = tokenObj.iat;
                
                if(tokenObj.exp !== 0 && tokenObj.exp !== null){
                  //   token expiry time in seconds
  					   expireSeconds = parseInt(tokenObj.exp);
                  
                  //   generating Expire timestamp
                        var tokenExpiryTime = moment( tokenIssuedAt, 'YYYY-MM-DD HH:mm:ss').toDate();
                        tokenExpiryTime.setSeconds(tokenExpiryTime.getSeconds() + expireSeconds);
                        return tokenExpiryTime;
                  
                }
                else{
                  if(isNewTokenGenerated === true){
                    console.error("Invalid tokenexpiry seconds");
                  }
                  return "";
                }
              }
              else{
                if(isNewTokenGenerated === true){
                  console.error("Invalid token issued at time");
                }
                return "";
              }
            }
            else{
              if(isNewTokenGenerated === true){
                console.error("Invalid customer id required customer id is "+resCustomerId, "token customer id is "+tokenObj.sub);
              }
              return "";
            }
            
          }
          else{
            if(isNewTokenGenerated === true){
              console.error("Invalid token");
            }
            return "";
          }
        }
        else{
          if(isNewTokenGenerated === true){
            console.error("Empty token object");
          }
          return "";
        }
      }
      else{
        if(isNewTokenGenerated === true){
          console.error("Invalid token");
        }
        return "";
      }
    }
    else{
      if(isNewTokenGenerated === true){
        console.error("Invalid token");
      }
      return "";
    }
  }
}


// function to generate a token
function generateToken(customerId){
  var GeneratedToken = "";
  var generateTokenUrl = "https://apps.ninjaas.com:8090/api/v3/jumkey/token/"+customerId;
  $.ajax({
        async: false,
        crossDomain: true,
        type: 'GET',
        timeOut: 15000,
        dataType: 'json',
        contentType: 'application/json',
        error: function (data) {
            console.log(data);
        },
        url: generateTokenUrl,
        statusCode: {
            200: function (data) {
                isNewTokenGenerated = true;
                GeneratedToken = data.token;
                if (typeof(Storage) !== "undefined") {
                    localStorage.setItem("token",GeneratedToken);
                }
            }
        }
    });
  return GeneratedToken;
}
